module.exports = __webpack_public_path__ + "img/cybersecurity-img-1.2cfab02e.jpg";